import { Children } from 'react';
import * as prod from 'react/jsx-runtime';
import rehypeParse from 'rehype-parse';
import rehypeReact from 'rehype-react';
import { unified } from 'unified';
import { rem } from '@blueprint/ui';

import { Box, List, ListItem } from 'components/blueprint';

import { StyledLink } from 'components/StyledLink/StyledLink';
import { InlineIconLink } from 'components/InlineIconLink/InlineIconLink';
import { ChatbotReplyFaq } from 'components/Reply/chatbot-reply-components/ChatbotReplyFaq/ChatbotReplyFaq';

import { getOnClickFunc } from './getOnClickFunc';

const REHYPE_REACT_CONFIG = {
  Fragment: prod.Fragment,
  jsx: prod.jsx,
  jsxs: prod.jsxs,
  components: {
    a: ({ children, onClick, ...rest }) => {
      /*
       * Display in reply faq
       */
      if (rest['data-request-type'] === 'faq') {
        return <ChatbotReplyFaq {...rest}>{children}</ChatbotReplyFaq>;
      }

      if (!onClick) {
        return (
          <StyledLink {...rest} underline>
            {children}
          </StyledLink>
        );
      }

      const onClickFunc = getOnClickFunc(onClick);

      if (onClick.includes('_blank')) {
        return (
          <InlineIconLink
            {...rest}
            icon="NewWindow"
            direction="right"
            onClick={onClickFunc}
            iconProps={{
              titleAccess: '(open in new window)',
              size: rem(16),
              width: rem(16),
              height: rem(16),
              marginLeft: rem(4),
            }}
            underline
          >
            {children}
          </InlineIconLink>
        );
      }

      return (
        <StyledLink {...rest} onClick={onClickFunc} underline>
          {children}
        </StyledLink>
      );
    },
    ul: ({ className, children, ...rest }) => (
      <List
        listStyleType={className === 'va-faq-ul' ? 'none' : 'disc'}
        {...rest}
        paddingLeft={0}
      >
        {Children.toArray(children).filter((child) =>
          child.hasOwnProperty('key'),
        )}
      </List>
    ),
    li: ({ children, ...rest }) => (
      <ListItem {...rest} marginBottom={rem(4)} key={children}>
        <Box
          css={{
            '&&&': {
              display: 'block',
            },
          }}
        >
          {children}
        </Box>
      </ListItem>
    ),
  },
};

export const transformer = unified()
  .use(rehypeParse, { fragment: true })
  .use(rehypeReact, REHYPE_REACT_CONFIG);
